export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Individuals", to: "/individuals" },
  { label: "Business Immigration", to: "/business" },
  { label: "Our Services", to: "/services" },
  { label: "About Us", to: "/about" },
  { label: "Testimonials", to: "/testimonials" },
  { label: "Insights", to: "/insights" },
  { label: "Contact", to: "/contact" },
];

export const SERVICE_CATEGORIES = [
  { value: "all", label: "All Services" },
  { value: "family", label: "Family & Partner" },
  { value: "visit", label: "Visit" },
  { value: "study", label: "Study" },
  { value: "work", label: "Work" },
  { value: "dependants", label: "Dependants" },
  { value: "settlement", label: "Settlement" },
  { value: "citizenship", label: "Citizenship" },
  { value: "ancestry", label: "Ancestry" },
  { value: "business", label: "Business" },
];

export const ARTICLE_CATEGORIES = [
  "UK Immigration News", "Family & Partner Visas", "Student Visas", "Work Visas",
  "Business Immigration", "Visit Visas", "Settlement & ILR", "British Citizenship",
  "Dependants & Family Members", "Policy Changes", "Tips & Guidance",
];

export const CONSULT_AREAS = [
  "Family & Partner", "Visit the UK", "Study in the UK", "Work in the UK",
  "Dependants", "Settlement / ILR", "British Citizenship", "UK Ancestry",
  "Business Immigration", "I'm not sure which service I need",
];

export const DISCLAIMER =
  "General information only. Immigration rules can change and individual circumstances matter.";
